import { defineAsyncComponent } from 'vue';
import type { DeckSlideMeta } from '../types';

/** @deprecated 请直接使用 `DeckSlideMeta`，保留别名仅为向后兼容引用 */
export type WgpSlideMeta = DeckSlideMeta;

export const wgpSlideMeta: DeckSlideMeta[] = [
  {
    id: 'cover',
    label: 'Frame 1',
    component: defineAsyncComponent(() => import('./Slide01Cover.vue')),
  },
  {
    id: 'what-moved',
    label: 'Frame 2',
    component: defineAsyncComponent(() => import('./Slide02WhatMoved.vue')),
  },
  {
    id: 'cedar-night',
    label: 'Frame 3',
    component: defineAsyncComponent(() => import('./Slide03CedarNight.vue')),
  },
  {
    id: 'what-we-did',
    label: 'Frame 4',
    component: defineAsyncComponent(() => import('./Slide04WhatWeDid.vue')),
  },
  {
    id: 'numbers',
    label: 'Frame 5',
    component: defineAsyncComponent(() => import('./Slide05Numbers.vue')),
  },
  {
    id: 'cedar-story',
    label: 'Frame 6',
    component: defineAsyncComponent(() => import('./Slide06CedarStory.vue')),
  },
  {
    id: 'why-it-happened',
    label: 'Frame 7',
    component: defineAsyncComponent(() => import('./Slide07WhyItHappened.vue')),
  },
  {
    id: 'next-week-plan',
    label: 'Frame 8',
    component: defineAsyncComponent(() => import('./Slide08NextWeekPlan.vue')),
  },
  {
    id: 'next-update',
    label: 'Frame 9',
    component: defineAsyncComponent(() => import('./Slide09NextUpdate.vue')),
  },
];
